<script lang="ts">
    import {link,push} from 'svelte-spa-router'
    import * as qs from 'qs';
    import * as numeral from 'numeral';
    import Header from './Header.svelte';
    import HeaderThemes from './HeaderThemes.svelte';
    import Footer from './Footer.svelte';
    import FooterThemes from './Footerthemes.svelte';
    import Clipboard from "svelte-clipboard";
    import Fa from 'svelte-fa'
    import { faLine } from '@fortawesome/free-brands-svg-icons';
    import { faSpinner,faCopy,faMinus,faMobileScreenButton,faCircleRight,faKey,faSave } from '@fortawesome/free-solid-svg-icons';
    import Swal from 'sweetalert2'
    

    document.body.scrollIntoView();
    let dataSetting = JSON.parse(window.localStorage.getItem('setting'))

    let loading = true
    let bnakDep = {}
    let bakList = []
    let creditwd = ""
    let isbutton = true

    let customerpass = ''
    let dataMember
    let isMember = false
    let acc_name = '';
    let step1 = true
    let step2 = false
    let password = ''
    let password1 = ''
    let password2 = ''
    let password3 = ''
    let password4 = ''
    async function setStep1() {
        const res = await fetch(window.localStorage.getItem("apiurl")+"register/resetpasswordstep1meta", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({
                member_tel:acc_name,
                member_password:customerpass
            })
        })

        const json = await res.json()
        if (json.statusCode==200) {
            step1 = false
            step2 = true
            setTimeout(() => {
                var obc = document.getElementById('password1')
                obc.focus();
            }, 500);
		}else{
            Swal.fire({
                heightAuto: false,
                title: 'แจ้งเตือน !',
                text: json.message,
                icon: 'warning',
                confirmButtonText: 'OK' 
            })
        }
    }
    async function setStep2() {
        if(password1 === ""  || password2 === "" || password3 === "" || password4 === "" || password1 ==undefined  || password2 ==undefined || password3 ==undefined || password4 ==undefined){
            Swal.fire({
                heightAuto: false,
                title: 'ไม่สามารถทำรายการได้',
                text: "กรุณาระบุรหัสผ่านให้ครบถ้วน",
                icon: 'error',
                confirmButtonText: 'OK' 
            })
            return
        }else{
            password =password1+''+password2+''+password3+''+password4
            const res = await fetch(window.localStorage.getItem("apiurl")+"register/resetpasswordstep2meta", {
                method: 'POST',
                headers:{
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'x-api-appid': window.localStorage.getItem("appid")
                },
                body: qs.stringify({
                    member_username:acc_name,
                    member_password:password
                })
            })
            const json = await res.json()
            if (json.statusCode==200) {
                Swal.fire({
                    heightAuto: false,
                    title: 'ทำรายการสำเร็จ',
                    text: "",
                    icon: 'success',
                    confirmButtonText: 'OK' 
                })
                push("/dashboard")
            }else{
                Swal.fire({
                    heightAuto: false,
                    title: 'ไม่สามารถทำรายการได้',
                    text: json.message,
                    icon: 'error',
                    confirmButtonText: 'OK' 
                })
            }
        }
    }
    async function getBalance() {
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/getbalance", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({})
        })
        const json = await res.json()
        if (json.statusCode==200) {
            acc_name = json.payload.username
		} else {
            window.localStorage.clear();
            push('/')
            throw new Error(json);
		}
    }
    const onKeyUp1 = (event) => {
        if(event.target.value>=0){
            var obc = document.getElementById('password2')
            obc.focus();
        }
    }
    const onKeyUp2 = (event) => {
        if(event.target.value>=0){
            var obc = document.getElementById('password3')
            obc.focus();
        }
    }
    const onKeyUp3 = (event) => {
        if(event.target.value>=0){
            var obc = document.getElementById('password4')
            obc.focus();
        }
    }
    const onKeyUp4 = (event) => {
    }
    function numberonly(evt){
        var e = evt;
        var inputElement = evt.target;
        var inputValue = inputElement.value;
        var length = inputValue.length;
        if(window.event){ // IE
            var charCode = e.keyCode;
           if(length>0){window.event.returnValue = false;}
            if (((charCode < 48) || (charCode > 57)) && ((charCode >= 3585) || (charCode <= 3664)) && (charCode != 13) && (charCode != 8) ) window.event.returnValue = false;
        } else if (e.which) { // Safari 4, Firefox 3.0.4
            var charCode = e.which
            if(length>0){charCode = e.preventDefault()}
            if (((charCode < 48) || (charCode > 57)) && ((charCode >= 3585) || (charCode <= 3664)) && (charCode != 13) && (charCode != 8) && length!=0) charCode = e.preventDefault();
        }
    }
    function numberonlyDot(evt){
        var e = evt;
        if(window.event){ // IE
            var charCode = e.keyCode;
            if (((charCode < 48) || (charCode > 57)) && ((charCode >= 3585) || (charCode <= 3664)) && (charCode != 13) && (charCode != 8) ) window.event.returnValue = false;
        } else if (e.which) { // Safari 4, Firefox 3.0.4
            var charCode = e.which
            if (((charCode < 48) || (charCode > 57)) && ((charCode >= 3585) || (charCode <= 3664)) && (charCode != 13) && (charCode != 8) && length!=0) charCode = e.preventDefault();
        }
    }
    getBalance()
</script>
<div class="default-home">
<div class="row  mb-5" style=" background-size:cover; background-repeat: no-repeat; background-position: center top;">
    <Header />
    <div class="col-12 text-center mt-2" style="padding-left:10px;padding-right:10px;" >
        <h4 class="header-n">เปลี่ยนรหัส (PIN)</h4>
    </div>
    {#if step1}
    <div class="row">
        <div class="mb-1 text-center">
            <span class="text-info"><Fa icon={faMinus}  size="2x"/></span>
            <span class="text-secondary"><Fa icon={faMinus}  size="2x"/></span>
        </div>
        <!-- <div class="cf-turnstile" data-sitekey="0x4AAAAAAACLn-OIe36odM6b" data-callback="javascriptCallback"></div> -->
        <div class="mb-3">
            <label for="customerphone" class="form-label" style="color:#FFF;"><Fa icon={faMobileScreenButton} /> รหัสผ่านเดิม (PIN)</label>
            <input type="text" class="form-control rounded-pill text-center" id="customerphone" placeholder="รหัสผ่านเดิม (PIN)" autocomplete="off"  on:keypress={() => numberonlyDot(event)} bind:value={customerpass}>
        </div>
        
        <div class="col-12 text-center d-grid gap-2">
            <button type="button" class="btn btn-dark rounded-pill btn-gd btn-news"  on:click={() => setStep1()} >ถัดไป <Fa icon={faCircleRight} /></button>
        </div>
    </div>
    {/if}
    {#if step2}
    <div class="row">
        <div class="mb-1 text-center">
            <span class="text-success"><Fa icon={faMinus}  size="2x"/></span>
            <span class="text-info"><Fa icon={faMinus}  size="2x"/></span>
        </div>
        <div class="mb-3">
            <label for="password" class="form-label"  style="color:#FFF;"><Fa icon={faKey} /> รหัสผ่านใหม่  (PIN)</label>
            <div style="display: flex;">
                <input type="number" class="form-control rounded-pill text-center btnpass" style="margin:0px 5px 0px 0px;" on:keypress={() => numberonly(event)} on:keyup={onKeyUp1}  id="password1" placeholder="" bind:value={password1} >
                <input type="number" class="form-control rounded-pill text-center btnpass" style="margin:0px 5px 0px 5px;" on:keypress={() => numberonly(event)} on:keyup={onKeyUp2}  id="password2" placeholder="" bind:value={password2} >
                <input type="number" class="form-control rounded-pill text-center btnpass" style="margin:0px 5px 0px 5px;" on:keypress={() => numberonly(event)} on:keyup={onKeyUp3}  id="password3" placeholder="" bind:value={password3} >
                <input type="number" class="form-control rounded-pill text-center btnpass" style="margin:0px 0px 0px 5px;" on:keypress={() => numberonly(event)} on:keyup={onKeyUp4}  id="password4" placeholder="" bind:value={password4} >
            </div>
        </div>
        
        <div class="col-12 text-center d-grid gap-2">
            <button type="button" class="btn btn-dark rounded-pill btn-gd btn-news" on:click={() => setStep2()} >ยืนยัน <Fa icon={faSave} /></button>
        </div>
    </div>
    {/if}
</div>
<Footer />
</div>
<div class="themes-home" style="display: none;">
    <div class="row mb-3 blog-deposits">
        <HeaderThemes/>
        <div class="col-12 text-center" ><h4  class="head-title ">เลือกช่องทางการฝากเงิน</h4></div>
        {#if step1}
    <div class="row">
        <div class="mb-1 text-center">
            <span class="text-info"><Fa icon={faMinus}  size="2x"/></span>
            <span class="text-secondary"><Fa icon={faMinus}  size="2x"/></span>
        </div>
        <div class="mb-3 text-center">
            
            <h6>เปลี่ยนรหัส (PIN)</h6>
        </div>
        <!-- <div class="cf-turnstile" data-sitekey="0x4AAAAAAACLn-OIe36odM6b" data-callback="javascriptCallback"></div> -->
        <div class="mb-3">
            <label for="customerphone" class="form-label"><Fa icon={faMobileScreenButton} /> รหัสผ่านเดิม (PIN)</label>
            <input type="text" class="form-control rounded-pill text-center" id="customerphone" placeholder="เบอร์โทรศัพท์" bind:value={customerpass}>
        </div>
        
        <div class="col-12 text-center d-grid gap-2">
            <button type="button" class="btn btn-dark rounded-pill btn-gd"  on:click={() => setStep1()}  style="color:#18ab8f !important" >ถัดไป <Fa icon={faCircleRight} /></button>
        </div>
    </div>
    {/if}
    {#if step2}
    <div class="row">
        <div class="mb-1 text-center">
            <span class="text-success"><Fa icon={faMinus}  size="2x"/></span>
            <span class="text-info"><Fa icon={faMinus}  size="2x"/></span>
        </div>
        <div class="mb-3 text-center">
            <h6>เปลี่ยนรหัส (PIN)</h6>
        </div>
        <div class="mb-3">
            <label for="password" class="form-label"><Fa icon={faKey} /> รหัสผ่านใหม่  (PIN)</label>
            <div style="display: flex;">
                <input type="number" class="form-control rounded-pill text-center btnpass" inputmode="numeric" pattern="[0-9]*" style="margin:0px 5px 0px 0px;" on:keypress={() => numberonly(event)} on:keyup={onKeyUp1}  id="password1" placeholder="" bind:value={password1} >
                <input type="number" class="form-control rounded-pill text-center btnpass" inputmode="numeric" pattern="[0-9]*" style="margin:0px 5px 0px 5px;" on:keypress={() => numberonly(event)} on:keyup={onKeyUp2}  id="password2" placeholder="" bind:value={password2} >
                <input type="number" class="form-control rounded-pill text-center btnpass" inputmode="numeric" pattern="[0-9]*" style="margin:0px 5px 0px 5px;" on:keypress={() => numberonly(event)} on:keyup={onKeyUp3}  id="password3" placeholder="" bind:value={password3} >
                <input type="number" class="form-control rounded-pill text-center btnpass" inputmode="numeric" pattern="[0-9]*" style="margin:0px 0px 0px 5px;" on:keypress={() => numberonly(event)} on:keyup={onKeyUp4}  id="password4" placeholder="" bind:value={password4} >
            </div>
        </div>
        
        <div class="col-12 text-center d-grid gap-2">
            <button type="button" class="btn btn-dark rounded-pill btn-gd" on:click={() => setStep2()}  style="color:#18ab8f !important">ยืนยัน <Fa icon={faSave} /></button>
        </div>
    </div>
    {/if}
    </div>    
</div>
<div class="themes-home-section" style="display: none;display:flex;">

</div>
<div class="footer-themes" style="display: none;">
    <FooterThemes />
</div>
<style>
    .btn-gd{
        /* --bs-btn-padding-y:0.1rem; --bs-btn-padding-x:0.3rem; --bs-btn-font-size:0.6rem;
        font-weight: 300; */
    }
    .bg-dk{
        background-color: black;
    }
    .text-sm{
        font-weight: 300;
        font-size: 0.6rem;
    }
    .pointer{
        cursor: pointer;
    }
    .bg-black{
        background: #000000ad !important;
    }
    .box-select-ch{
        border: 1px solid grey;
        border-radius: 10%;
        cursor: pointer;
    }
    .box-select-ch:hover{
        /* border: 2px solid gold; */
        box-shadow: 0px 0px 10px 3px gold;
    }
    .active .box-select-ch{
        border: 1px solid gold;
        box-shadow: 0px 0px 10px 3px gold;
    }
    .active {
        color: gold;
    }
    .default-home .card-body{
        padding: 5px;
    }
     input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
    }

    /* Firefox */
    input[type=number] {
    -moz-appearance: textfield;
    }
    :global(.row){
        margin: 0px !important;
    }
</style>